import _ from 'lodash';
import { validateSDKChartConfigEditorDefinition } from '../ts-to-chart/validate-chart-config/util';
import { validateSDKVisualPropEditorDefinition } from '../ts-to-chart/validate-visual-props/util';
export const validateCustomChartValidationEventResponsePayload = (payload, logger) => {
    const { chartConfigEditorDefinition, visualPropEditorDefinition } = payload;
    const errorList = [];
    if (!_.isNil(chartConfigEditorDefinition) &&
        !validateSDKChartConfigEditorDefinition(chartConfigEditorDefinition, logger)) {
        errorList.push('chartConfigEditorDefinition is invalid');
    }
    if (!_.isEmpty(visualPropEditorDefinition) &&
        !validateSDKVisualPropEditorDefinition(visualPropEditorDefinition, logger)) {
        errorList.push('visualPropEditorDefinition is invalid');
    }
    if (errorList.length > 0) {
        return {
            isValid: false,
            validationErrorMessage: errorList,
        };
    }
    return {
        isValid: true,
    };
};
//# sourceMappingURL=util.js.map